import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  OrchestrationRunDetailsDialogComponent,
  OrchestrationRunDetailsDialogData,
} from './orchestration-run-details-dialog.component';

@Injectable({ providedIn: 'root' })
export class OrchestrationRunDetailsDialogService {
  constructor(private readonly dialog: MatDialog) {}

  openDialog(runId: string) {
    this.dialog.open<OrchestrationRunDetailsDialogComponent, OrchestrationRunDetailsDialogData>(
      OrchestrationRunDetailsDialogComponent,
      {
        height: '90vh',
        width: '90vw',
        maxWidth: '1400px',
        data: { runId },
      },
    );
  }
}
